// Numéro WhatsApp Business de Papicoo (confirmé : +33 7 53 82 77 47)
export const PAPICOO_WHATSAPP = "33753827747";

export const papicooWhatsApp = (message) =>
  `https://wa.me/${PAPICOO_WHATSAPP}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
